module.exports = __webpack_public_path__ + "img/decline-general.003b8d66.svg";